import React from "react";
import { isCoach } from "../../../../utils/user-helpers";
import { getUserToRequest } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";

const NavigationSections = ({
  linksArr,
  activeUser,
  organizationOwner,
  urlStart,
  urlEnd,
  pathNameWithoutEndingSlash,
  view,
  date,
}) => {
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const isPushDemoAccount =
    activeUser.email && activeUser.email.includes("+push@");

  return linksArr.map(({ route, label, className, queryParams, key }, idx) => {
    if (key === "annualPlanner" && !isCoach(activeUser)) {
      return null;
    }

    if (key === "strengthMetrics" && !!userToRequest.hideStrengthMetrics) {
      return null;
    }

    if (key === "checkInSummary" && !isCoach(activeUser)) {
      return null;
    }
    if (
      key === "accountability" &&
      (userToRequest.subscription || isPushDemoAccount)
    ) {
      return null;
    }
    if (key === "blockReview" && !isCoach(activeUser)) {
      return null;
    }

    const active = `${urlStart}${route}` === pathNameWithoutEndingSlash;
    const userMeasure =
      userToRequest.intensityMeasure === "rir" ? "RiR" : "RPE";
    const labelToShow = label === "RPE Table" ? `${userMeasure} Table` : label;

    const redirect =
      label === "RPE Table"
        ? `${urlStart}${route}?${
            view ? "view=day&" : ""
          }display=repMax${urlEnd}`
        : `${urlStart}${route}?${view ? "view=day&" : ""}date=${date}${urlEnd}`;

    return (
      <li
        key={`${key}-${idx}`}
        className={`${active ? "active" : ""}${
          ["blockReview"].includes(key)
            ? " mobile-hidden"
            : "" // hidding for mobile cause responsive is not yet ready
        }`}
      >
        <a
          href={redirect}
          className={`linkx alt${className ? ` ${className}` : ""}`}
        >
          {labelToShow}
        </a>
        <img
          className="only-show-mobile"
          src="/img/new-icons/arrow-right.svg"
        />
        {/* {label === "Check-in Summary" ||
          (label === "Body Measurements" && (
            <span role="new-report"> (new)</span>
          ))} */}
      </li>
    );
  });
};

export default NavigationSections;
